<template>
  <main role="main">
    <b-container class="">
      <div class="d-flex flex-row justify-content-center">
        <div class="login-box">
          <!-- <h4 class="mb-3 text-center">{{ $t("loginPageTitle") }}</h4> -->
          <div class="card" style="border:1px;border-radius: 16px;">
            <div class="card-body">
              <h4 class="mb-1 text-center title">{{ $t("loginPageTitle") }}</h4>
              <p class="mb-4 text-center">
                {{ $t("welcomeToGoMeet") }}
              </p>
              <b-form class="mb-3" @submit.prevent="onSubmit">
                <div class="form-group">
                  <label for="input-username">{{ $t("usernameOrEmail") }}</label>
                  <div class="input-group mb-3">
                    <input id="input-username" :placeholder="$t('hintUsernameOrEmail')" type="text"
                      class="form-control fh-45" v-model="username" required>
                    <div class="input-group-append">
                      <div class="input-group-text btn-form">
                        <span class="fas fa-envelope"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="input-password">{{ $t("password") }}</label>
                  <div class="input-group mb-3">
                    <input id="input-password" :placeholder="$t('password')" :type="showPassword ? 'text' : 'password'"
                      class="form-control fh-45" v-model.trim="password" required>
                    <div class="input-group-append">
                      <div class="input-group-text btn-form" @click="showPassword = !showPassword">
                        <span class="fas" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></span>
                      </div>
                    </div>
                  </div>
                </div>

                <!--                <div class="d-flex flex-row align-items-center justify-content-between">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="remember" v-model="rememberMe">
                    <label class="custom-control-label" for="remember">{{ $t("stayLoggedIn") }}</label>
                  </div>
                  <div>
                    <button type="submit" class="btn btn-primary btn-block" :disabled="isLoading">{{ $t("login") }}</button>
                  </div>
                </div>-->

                <div class="d-flex flex-row justify-content-between mt-2">
                  <div></div>
                  <router-link to="/forgot-password">{{ $t("forgotPasswordQMark") }}</router-link>
                </div>
                <div v-if="errorMsg" class="text-danger">{{ $t(errorMsg) }}</div>
                <div>
                  <button type="submit" class="btn btn-primary btn-block fh-45 mt-3" :disabled="isLoading">{{
                    $t("login") }}</button>
                </div>

                <div class="divider mt-4" v-if="enableSsoLogin || enableSsoGoogle || enableSMELogin">{{ $t("or") }}
                </div>

                <div class="text-center mb-3">
                  <img v-if="enableSsoLogin" type="button" class="mr-3 mt-3 sso-img" src="images/logoVNPT3.png"
                    alt="Logo" @click="onClickSsoLogin" />
                  <img v-if="enableSsoGoogle" type="button" id="signInButton" class="mr-3 mt-3 sso-img"
                    src="images/logoGoogle.png" alt="Logo" />
                </div>
                <div class="text-center mb-3" v-if="enableSMELogin">
                  <b-button class="btn-block sso-login" variant="outline-dark" @click="onClickSmeLogin"
                    style="color: orange;">
                    <img class="mr-1" src="images/logoVNPT2.png" alt="Logo" width="36px" /> {{ $t("loginSME") }}
                  </b-button>
                  <b-button class="btn-block sso-login" variant="outline-dark" @click="onClickSsoLogin">
                    <img class="mr-1" src="images/logoVNPT2.png" alt="Logo" width="36px" /> {{ $t("loginVnptSso")
                    }}</b-button>
                </div>
                <div class="text-center mt-4">
                  <span>{{ $t("dontHaveAccount") }}
                    <router-link to="/signup">{{ $t("registerAccount") }}</router-link>
                  </span>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>
.title {
  font-size: 26px;
  font-weight: 600;
}

.fh-45 {
  height: 45px;
}

.login-box {
  width: 500px;
}

.divider {
  display: flex;
  align-items: center;
  color: #ced4da;
}

.divider::before,
.divider::after {
  flex: 1;
  content: '';
  padding: 0.1px;
  background-color: #ced4da;
  margin: 5px;
}

.sso-login {
  border-color: #a5a5a5;
}

.sso-img {
  width: 45px;
}

.sso-login:hover,
.sso-login:active {
  border-color: #0066b4 !important;
  background: inherit !important;
  color: #0066b4 !important;
}

//.card {
//  background-color: white !important;
//}</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from "@/components/BaseComponent";
import * as userService from "@/service/userService";
import environment from "@/environment";

import jwt_decode from "jwt-decode";
import Cookies from "js-cookie";

import firebaseConfig from '../../firebaseConfig';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from 'firebase/auth';
import { enumLoginType } from '../enums/loginType';

const isHttps = location.protocol === 'https:';
const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  path: '/',
  secure: isHttps,
  sameSite: isHttps ? 'None' : 'Lax'
};


@Component
export default class UserLogin extends BaseComponent {

  enableSsoLogin = window["vnptEConferencePortalEnableSsoLogin"] || true;

  enableSsoGoogle = window["vnptEConferencePortalEnableSsoGoogle"] || true;

  enableSMELogin = window["vnptEConferencePortalEnableSmeLogin"] || false;

  username = "";
  password = "";
  rememberMe = false;
  errorMsg = null;

  showPassword = false;

  isLoading = false;

  mounted() {
    const app = initializeApp(firebaseConfig);
    // Tìm và gắn sự kiện click cho nút đăng nhập
    const signInButton = document.getElementById("signInButton");
    if (signInButton) {
      signInButton.addEventListener("click", this.onClickSsoGoogle.bind(this));
    }
  }

  onClickSsoLogin() {
    const service = location.origin + environment.appBaseUrl;
    localStorage.setItem("vnptSsoService", service);
    location.href = "https://id.vnpt.com.vn/cas/login?" + new URLSearchParams({ service }).toString();
  }

  onClickSmeLogin() {
    location.href = "https://idp-sme.vnpt.vn/oauth2/authorize?response_type=code&client_id=OzElOq7JW1NKtfgpnafe0fbzwGoa&scope=openid&redirect_uri=https://econference.devitkv2.com/app";
  }

  /// Login with Google
  async onClickSsoGoogle() {
    try {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      // Cấu hình Google Sign-In
      provider.setCustomParameters({
        prompt: "select_account",
      });
      // Thực hiện đăng nhập
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const email = user.email.toLowerCase();
      const token = await user.getIdToken();
      // Gửi token đến API thông qua userService
      const resultData = await userService.SigninGoogle({
        token
      });
        if (resultData?.data) {
        const userBE = resultData.data;
        const decodedJwt: any = jwt_decode(userBE.token);
        Cookies.set("userId", userBE.id.toString(), COOKIE_OPTIONS);
        Cookies.set("token", userBE.token, COOKIE_OPTIONS);
        Cookies.set("user", JSON.stringify(userBE), COOKIE_OPTIONS);
        Cookies.set("tokenExpire", decodedJwt.exp.toString(), COOKIE_OPTIONS);
        // Đánh dấu phiên đăng nhập SSO để bỏ qua đổi mật khẩu
        localStorage.setItem("signInBySSO", enumLoginType.GOOGLE);
        // Hiển thị thông tin người dùng
        location.href = environment.appBaseUrl;
      } else {
        await signOut(auth); // Đăng xuất nếu token không hợp lệ
        throw new Error("Lỗi xác thực người dùng");
      }
    } catch (error) {
      if (error.code === "auth/cancelled-popup-request" || error.code === "auth/popup-blocked") {
        /// ignore if error from sso popup
        return;
      }
      console.error("Lỗi đăng nhập: ", error);
      this.errorMsg = "Đăng nhập không thành công. Vui lòng thử lại!";
    }
  }
  async onSubmit() {

    try {
      this.errorMsg = null;
      this.isLoading = true;
      const user = await userService.signIn(this.username, this.password, this.rememberMe);

      if (user.mustChangePassword && !userService.isSsoLogin()) {
        location.href = environment.appBaseUrl + "#/change-password";
      } else {
        location.href = environment.appBaseUrl;
      }

    } catch (e) {
      this.errorMsg = this.returnErrorMessage(e);
    } finally {
      this.isLoading = false;
    }
  }

};
</script>
